import { useEffect, useState } from "react";
import classNames from "classnames";
import { Button } from "../../../components/button/button";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { useParams } from "react-router";
import { InputBlock } from "./InputBlock";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import KpiAPI from "../../../api/KpiAPI";
import { Spring } from "../../../components/spring/spring";
import { UploadFile } from "../../../components/uploadFile/uplodeFile";

import styles from "./addKpiTask.module.css";

import { Text } from "../../../components/text/text";

export const AddKPITaskPage = () => {
    const { cafeId } = useParams();

    const [category, setCategory] = useState("");
    const [categoryError, setCategoryError] = useState(false);

    const [goal, setGoal] = useState(0);
    const [goalError, setGoalError] = useState(false);

    const [date, setDate] = useState(new Date());
    const [isXlsxFile, setIsXlsxFile] = useState(false);
    const [file, setFile] = useState(null);
    const [fileError, setFileError] = useState(false);

    useEffect(() => {
        setGoalError(false);
    }, [goal]);

    useEffect(() => {
        setCategoryError(false);
    }, [category]);

    useEffect(() => {
        setFileError(false);
    }, [file]);

    const validateData = () => {
        let error = false;

        if (goal <= 0) {
            setGoalError(true);
            error = true;
        }

        if (category.length <= 1) {
            setCategoryError(true);
            error = true;
        }

        return error;
    }

    const navigate = useAnimatedNavigate()
    const [loading, setLoading] = useState(false);

    const onDownloadTemplate = () => {
        if (!cafeId) return;

        try {
            KpiAPI.downloadKpiPlanTemplate(cafeId);
        } catch (error) {
            console.error(error);
        }
    }

    const onSave = () => {
        if (!cafeId) return;

        if (isXlsxFile) {
            if (!file) {
                setFileError(true);
                return;
            }

            setLoading(true);
            KpiAPI
                .batchCreateKpiTasks(cafeId, file)
                .then(() => navigate(`/superadmin/cafe/${cafeId}/kpi`))
                .catch(console.error)
                .finally(() => setLoading(false));
            return;
        }

        if (validateData()) return;

        setLoading(true);
        KpiAPI
            .createKpiScheme(cafeId, {
                name: category,
                goal: goal,
                date: date,
            })
            .then(() => navigate(`/superadmin/cafe/${cafeId}/kpi`))
            .catch(console.error)
            .finally(() => setLoading(false));
    }

    return (
        <>
            <AdminHeader title="Добавить план" />

            <div className={styles.buttons}>
                <Button
                    text="Добавить вручную"
                    view="thin"
                    type={!isXlsxFile ? "primary" : "secondary"}
                    onClick={() => setIsXlsxFile(false)}
                />
                <Button
                    text="Через файл"
                    view="thin"
                    type={isXlsxFile ? "primary" : "secondary"}
                    onClick={() => setIsXlsxFile(true)}
                />
            </div>

            {
                !isXlsxFile &&
                <Text as="div" variant="body" className="page_description" >
                    На этой странице Вы можете добавить план продаж по указанной категории.
                </Text>
            }

            {
                isXlsxFile &&
                <>
                    <Text as="div" variant="body" className="page_description" >
                        Скачайте пример файла и загрузите заполненный XLSX для добавления планов продаж.
                    </Text>

                    <Button
                        type="secondary"
                        text="Скачать пример XLSX"
                        onClick={onDownloadTemplate}
                        disabled={loading}
                    />

                    <div className={styles.input_block}>
                        <div className={classNames(styles.input_block_title, { [styles.error]: fileError })}>
                            Файл с KPI (xlsx)
                        </div>
                        <UploadFile
                            selectedFile={file}
                            setSelectedFile={setFile}
                            accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        />
                    </div>
                </>
            }

            {
                !isXlsxFile &&
                <>
                    <InputBlock
                        type="text"
                        title="Категория продаж"
                        value={category}
                        setValue={setCategory}
                        error={categoryError}
                    />

                    <InputBlock
                        type="number"
                        title="План по продажам"
                        value={goal}
                        setValue={setGoal}
                        error={goalError}
                    />

                    <InputBlock
                        type="date"
                        title="Дата начала"
                        value={date.toISOString().split("T")[0]}
                        setValue={(val) => {
                            try {
                                const newDate = new Date(val);
                                newDate.toISOString();
                                setDate(newDate);
                            } catch {
                                setDate(prev => prev);
                            }
                        }}
                    />
                </>
            }

            <Spring />

            <Button
                text={isXlsxFile ? "Загрузить план" : "Добавить план"}
                onClick={onSave}
                disabled={loading}
            />
        </>
    )
}
